import React, {useEffect, useState} from "react";
import { useParams,} from "react-router-dom";
import Topbar from '../Component/Topbar';
import '../Css/Studentcoursegrade.css';
import StudentCourseNavbar from "../Component/StudentCourseNavbar";
import StdGrade from "../Component/StdGrade";

function StudentCourseGrade(){
    const { _id } = useParams(); 
    const [course, setCourse] = useState(null);

    useEffect(() => {
        fetchCourseDetails(_id);
    }, [_id]);

    const fetchCourseDetails = async (courseId) => {
        try {
            const response = await fetch(`https://educonnectbackend-mvso.onrender.com/courses/addcourses/${courseId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch course details');
            }
            const data = await response.json();
            setCourse(data);
        } catch (error) {
            console.error('Error fetching course details:', error);
        }
    };

    return (
        <>
        <div className='stdheaderrtop'>
        <Topbar/>
        </div>
        <div className="stdgradedashall">
            {course && (
                <div className="stdgradedashinfo">
                    <div className="stdgradetitle">
                    <h5>Course : {course.courseTitle}</h5>
                    </div>
                    <div className="stdgradecode">
                    <h5>Code: {course.courseCode}</h5>
                    </div>
                    <div className="stdgradeduration">
                    <h5>Duration: {course.courseDuration} Weeks</h5>
                    </div>
                </div>
            )}
            <div className="stdgradedashcontent">
                <div className="stdgradenav">
                    <StudentCourseNavbar/>
                </div>
                <div className="stdgradecontents">
                <div className="stdleftgradelist">
                    <StdGrade/>
                    </div>   
                </div>

            </div>
        </div>
        </>
    );
}

export default StudentCourseGrade;